<template>
 <div>
    <h1>{{ settingObj.name }} : Soumissions</h1>
        <div class="submissions_area">				
            <div class="pl-list" id="submissions" >
                <div class="header">
                    <div class="header_line">
                    <div id="header_col1" class="header_col col1">Mot(s)</div><div id="header_col2" class="header_col col2">Date d’oubli</div><div id="header_col3" class="header_col col3">&nbsp;</div>
                    </div>
                </div>
                <div class="content" ref="submissionsBox">
                    <submissionline v-for="(sub, index) in submissions"  :key='sub.word' :submissionObj='sub' :class="{selectedLine:(index == indexSelectedLine)}" v-on:selectLine='selectIndex(index)' @deleteLigne="deleteSubmission(sub.word, index)"></submissionline>

                    <div class="dummyline" :style="{'height': dummySubmissionsHeight+'px'}">
                        <div class="col col1">&nbsp;</div>
                    </div>
                </div>
                <div class=footer>
                    <div class="buttons">
                        <select id="lst_dico" size="1" disabled="disabled" v-model="selectedDicoName" @change="selectDicoToSubmit()">
                            <option v-for="(dico) in dicos" :key="dico.name" :value='dico.name' >{{ dico.name }}</option>
                        </select>
                        <button id="btn_add" type="button" class="liste_btn boutonTableau" :disabled="indexSelectedLine < 0 || this.dicos.length == 0" title="Ajoute la soumission au dictionnaire sélectionné"  @click='addWordInDict()'>Ajouter</button>
                        <button id="btn_delete" type="button" class="liste_btn boutonTableau" :disabled="indexSelectedLine < 0" title="Supprime la soumission sélectionnée" @click='deleteSelectedSubmission()'>Supprimer</button>
                        <button id="btn_deleteall" type="button" class="liste_btn boutonTableau" :disabled="submissions.length < 1" title="Vide la liste de toutes les soumissions" @click='askForClearSub()' >Vider</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="warning">
            <i id="warning_icon" class="material-icons">warning_amber</i>
            <span id="warning_txt"> Tout changement dans cette page sera effectif <u>15 minutes</u> après avoir cliqué sur "Envoyer les modifs" en haut à droite.</span>
        </div>
    </div>
</template>

<script>
    import { diagonalbackURL, defaultConfig, URLEncodedConfig } from "../constantes";
    import axios from 'axios'
    import FctUtils from '@/components/FctUtils';
    import SubmissionLine from '@/components/SubmissionLine';

    export default {
        name:"Submission",
        components:{
            "submissionline":SubmissionLine,
        },
        mixins: [FctUtils],
        props:{
            settingProps: {type:String}, // arrive depuis un push -> String
        },
        data(){
            return {
                settingObj: {},
                submissions:{},
                dicos:{},
                indexSelectedLine :-1,
                selectedDicoName : {},
                dummySubmissionsHeight:25,
                timerSubmission:{},

                nomove:true,
            }
        },
        created() {
            this.selectedDicoName = localStorage.getItem('submitToDicos');


            // Si pas de settings, on regarde s'il n'y en a pas un deja dans le store
            if (!FctUtils.methods.noEmpty(this.settingProps)) {
                this.settingObj = this.$store.getters.setting;
            }
            else {
                this.settingObj = JSON.parse(this.settingProps);
            }

            // Si Setting Ok, on affiche les soumissions correspondantes
            if (FctUtils.methods.noEmpty(this.settingObj)) {
                this.getSubmissions(); 
                this.selectHash();

                if (this.timerSubmission) clearInterval(this.timerSubmission);
                this.timerSubmission = setInterval(function () { 
                    this.getSubmissions(); 
                }.bind(this), 10000);

                // Reecup la liste des dictionnaires (pour choisir dans quel dico on soumet le mot)
                axios.get(diagonalbackURL + "/settings/"+ this.settingObj.id + "/dictionaries", defaultConfig)
                    .then(reponse => {
                        this.dicos = reponse.data; //.filter(function(dico) { return dico.installed});
                        if (this.dicos.length > 0) {
                            $('#lst_dico').removeAttr("disabled");

                            var dicoFound = false;
                            for(var i = 0; i < this.dicos.length; i++) {
                                if (this.dicos[i].name == this.selectedDicoName) {
                                    dicoFound = true;
                                    break;
                                } 
                            }


                            if (!dicoFound) {
                                this.selectedDicoName = this.dicos[0].name  
                            }
                        }

                    })
                    .catch(error => {
                        this.emitter.emit('showPopup', {
							mode:  'error_custom',
							title: 'Soumissions',
							text:  'Les soumissions sont actuellement indisponibles.',
						});
                        FctUtils.methods.errorHandler(error);
                    });
            }
            else {
                // si toujours pas de setting, on retourne vers la selection de la configuration
                this.$router.push({name:"SelectDicoSetting", params: {
                    from: "Submission"
                } })
            }
        },
        mounted() {

            this.emitter.on('removeSubmission_All', aData => {
                this.deleteAllSubmission(aData)
            });
        },
        unmounted() {
            this.emitter.off('removeSubmission_All');

            if (this.timerSubmission) clearInterval(this.timerSubmission);
        },
        methods : {
            getSubmissions() { 
                axios.get(diagonalbackURL + "/settings/"+this.settingObj.id+"/submissions", defaultConfig)
                .then(reponse => {
                    this.submissions = reponse.data;

                    if (this.submissions.length > 0) {
                        if (this.indexSelectedLine == -1 ) {
                            this.indexSelectedLine = 0;
                            this.selectHash();
                        }
                    }
                    else {
                        this.indexSelectedLine = -1;
                    }

                    this.calcDummySubmissionsHeight();
                })
                .catch(error => {
                    //this.submissions = ["Erreur de chargement", error]
                    FctUtils.methods.errorHandler(error)
                    this.emitter.emit('showPopup', {
                        mode:  'error_custom',
                        title: 'Soumissions',
                        text:  'Les soumissions ne sont pas disponibles pour le moment.',
                    });
                });
            },
            addWordInDict() {
                var word = this.submissions[this.indexSelectedLine].word;
                var dico = this.selectedDicoName;

                this.$router.push({name:"DicoFrame", params: {diconame: dico, word:word} });
            },
            deleteSelectedSubmission() {
                var word = this.submissions[this.indexSelectedLine].word;
                this.deleteSubmission(word);
            },
            deleteSubmission(word, index) {
                var self = this;
                const params = { ...URLEncodedConfig };
                params.data = 'word='+ word;
                var currentIndex = (index) ? index : this.indexSelectedLine;
                // on compare a length -1 vu qu'on va supprimé un mot.
                if (currentIndex >= this.submissions.length-1) currentIndex--;
                this.indexSelectedLine = currentIndex;

                axios.delete(diagonalbackURL + "/settings/"+this.settingObj.id + "/submissions",  params)
                .then(reponse => {
                    this.getSubmissions();
                 })
                .catch(error => {
                    this.emitter.emit('showPopup', {
                        mode:  'error_custom',
                        title: 'Soumissions',
                        text:  'Erreur lors de la suppression, veuillez recharger la page.',
                    });
                    FctUtils.methods.errorHandler(error)
                });
            },
            askForClearSub() {
                this.emitter.emit('showPLForm', {mode:'formSub_removeAll', data:''});
            },
            deleteAllSubmission(){
                // for each this.submissions -> delete
                for(var i in this.submissions) {
                    var sub = this.submissions[i];
                    this.deleteSubmission(sub.word);
                }
                // Attention pas de recharge aprés l'appel, le form est fermé via un appel interne
            },
            selectIndex(index) {
                if (index != undefined && !isNaN(index)) {
                    if (index >= this.submissions.length) {
                        this.indexSelectedLine = this.submissions.length-1;
                    }
                    else {
                        this.indexSelectedLine = index;
                    }
        
                    if (!isNaN(this.indexSelectedLine) && this.indexSelectedLine != undefined) {
                        history.replaceState('', '', "#" + this.indexSelectedLine);
                    }
                }
            },
            selectHash() {
                // On reaffecte la ligne courante si besoin
                if (location.hash != null) {
                    var currentSub = parseInt(location.hash.replace("#", ''));

                    if (currentSub != undefined && currentSub != null && currentSub != NaN) {
                        this.selectIndex(currentSub);
                        this.nomove = false;
                    }
                } 
            },
            selectDicoToSubmit() {
                localStorage.setItem('submitToDicos', this.selectedDicoName);
            },
            calcDummySubmissionsHeight() {
                var calcHeight = 25;
                if (this.$refs.submissionsBox != undefined && this.submissions.length != undefined) {
                    calcHeight = this.$refs.submissionsBox.scrollHeight - (this.submissions.length*26) - 5;
                }

                this.dummySubmissionsHeight = calcHeight;
            },
            moveToCurrentLine() {
                // la function nextTick permet d'attendre que le DOM soit stable avant de faire une modification
                // Comme on utilise la classe .selectedLine qui depend de la data dynamique "this.indexSelectedLine" 
                // Suivant l'etat du DOM il se peux que this.indexSelectedLine soit en place mais pas que .selectedLine soit appliqué
                // bref un joli casse tête... cette solution permet d'attendre le DOM.
                //
                this.$nextTick(function () {
                    var element = document.getElementsByClassName("selectedLine")[0];
                    if (!element) { this.selectHash(); }
                    if (element) element.scrollIntoView({behavior: 'auto'});   
                });
            },
        },
        updated() {
            if (!this.nomove) {
                this.moveToCurrentLine();
                this.nomove = true;
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#submissions.pl-list #header_col2 {
    border-right-width: 0;
}

</style>
